<div class="table-style">
    <div style="margin: 8px;">
        @if(claimTimesheetData.length > 0) {
        <ppl-list-table [customDataLoaded]="true" [disableSearch]="true" [showCustomSearch]="false" [cols]="cols"
            [enableActions]="false" [data]="claimTimesheetData" [disableSelection]="true" [gridTitle]="false"
            [pagination]="true" [loadPage]="true" [from]="'claimadj'">
        </ppl-list-table>
        } @else {
        <p>No Results Found</p>
        }
    </div>
</div>